import React, { useState } from "react";
import { IEpiProps, SearchContext } from "../models/vertex-search-page-models";
import { useVertexSearchContext, useVertexSearchDispatch } from "../reducers/vertex-search-page-provider";
import { SearchResultsAllAap } from "./search-results-all-aap";

interface IProps {
    isLoading: boolean
    isLoadingMoreResults: boolean
    onLoadMore: () => void;
    onShopFiltersChange: (shopFiltersString: string) => void;
}

interface IContextProps {
    epiProps: IEpiProps
    currentSearchContext: string
}

export const SearchResultsShop = (props: IProps) => {
    const { currentSearchContext }: IContextProps = useVertexSearchContext();

    if (currentSearchContext == SearchContext.ShopAAP)
        return (
            <div className="vertex-search-shop-results">
                <SearchResultsAllAap
                    isLoading={props.isLoading}
                    isLoadingMoreResults={props.isLoadingMoreResults}
                    onLoadMore={props.onLoadMore}
                    onRelatedQuestionClick={null} //No related questions in SHOP context.
                />

            </div>
        )
}